module.exports = __webpack_public_path__ + "static/media/shipping-and-delivery.1d5d47ac.svg";